import type React from 'react';
import {
  FiServer,
  FiEye,
  FiPhone,
  FiLifeBuoy,
  FiSettings,
  FiActivity,
  FiPackage,
  FiShield,
  FiGlobe,
  FiClock,
  FiCheckCircle,
  FiArrowRight,
  FiMail,
  FiMapPin,
  FiLinkedin,
  FiFacebook,
  FiMenu,
  FiX,
  FiStar,
  FiAlertCircle,
  FiSend  // Adding FiSend for Telegram
} from 'react-icons/fi';
import {
  BsBuilding,
  BsPeople,
  BsBarChart,
  BsLightningCharge,
  BsGrid,
  BsAward,
  BsTelegram  // Adding BsTelegram as an alternative
} from 'react-icons/bs';

type IconName =
  | 'network'
  | 'cctv'
  | 'phone'
  | 'support'
  | 'automation'
  | 'monitoring'
  | 'allinone'
  | 'transparency'
  | 'flexibility'
  | 'experience'
  | 'proactive'
  | 'quality'
  | 'factory'
  | 'clinic'
  | 'retail'
  | 'arrow'
  | 'email'
  | 'location'
  | 'linkedin'
  | 'facebook'
  | 'menu'
  | 'close'
  | 'star'
  | 'alert'
  | 'clock'
  | 'telegram';  // Added telegram icon

interface IconProps {
  name: IconName;
  className?: string;
  size?: number;
}

const Icon: React.FC<IconProps> = ({ name, className = '', size = 24 }) => {
  const renderIcon = () => {
    switch (name) {
      // Services
      case 'network':
        return <FiServer size={size} />;
      case 'cctv':
        return <FiEye size={size} />;
      case 'phone':
        return <FiPhone size={size} />;
      case 'support':
        return <FiLifeBuoy size={size} />;
      case 'automation':
        return <FiSettings size={size} />;
      case 'monitoring':
        return <FiActivity size={size} />;

      // Advantages
      case 'allinone':
        return <FiPackage size={size} />;
      case 'transparency':
        return <FiShield size={size} />;
      case 'flexibility':
        return <BsGrid size={size} />;
      case 'experience':
        return <BsAward size={size} />;
      case 'proactive':
        return <FiAlertCircle size={size} />;
      case 'quality':
        return <FiCheckCircle size={size} />;

      // Case studies & businesses
      case 'factory':
        return <BsBuilding size={size} />;
      case 'clinic':
        return <BsPeople size={size} />;
      case 'retail':
        return <BsBarChart size={size} />;

      // UI elements
      case 'arrow':
        return <FiArrowRight size={size} />;
      case 'email':
        return <FiMail size={size} />;
      case 'location':
        return <FiMapPin size={size} />;
      case 'linkedin':
        return <FiLinkedin size={size} />;
      case 'facebook':
        return <FiFacebook size={size} />;
      case 'telegram':
        return <BsTelegram size={size} />;  // Added telegram icon implementation
      case 'menu':
        return <FiMenu size={size} />;
      case 'close':
        return <FiX size={size} />;
      case 'star':
        return <FiStar size={size} />;
      case 'alert':
        return <FiAlertCircle size={size} />;
      case 'clock':
        return <FiClock size={size} />;

      default:
        return <FiGlobe size={size} />;
    }
  };

  return <span className={className}>{renderIcon()}</span>;
};

export default Icon;
